import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  successRemoveForm,
} from './actions';

export function* requestOperacaoAbastecimentos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoesabastecimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoAbastecimento({ payload }) {
  try {
    const { idoperacaoabastecimento, params, query } = payload;

    yield call(
      api.delete,
      `movimentacoesabastecimentos/${idoperacaoabastecimento}`,
      { params: query }
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaoabastecimento, params } = payload;

    yield call(api.post, 'movimentacoesabastecimentos', operacaoabastecimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idoperacaoabastecimento } = payload;

    const { data } = yield call(
      api.get,
      `movimentacoesabastecimentos/${idoperacaoabastecimento}`
    );

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { operacaoabastecimentos, params } = payload;

    yield call(api.put, 'movimentacoesabastecimentos', operacaoabastecimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'movimentacoesabastecimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}
export function* deletarCliente({ payload }) {
  try {
    const { operacaoabastecimentos, params } = payload;

    let idoperacaoabastecimento = '';

    idoperacaoabastecimento = operacaoabastecimentos.idmovimentacao;
    idoperacaoabastecimento = `${idoperacaoabastecimento}/${operacaoabastecimentos.idposto}`;

    const justificativa = operacaoabastecimentos.justificativa || '';

    const obj = {};
    obj.justificativa = justificativa;

    yield call(
      api.delete,
      `movimentacoesabastecimentos/${idoperacaoabastecimento}`,
      { params: obj }
    );
    yield put(successRemoveForm({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaoabastecimento/OPERACAOABASTECIMENTOS_IN_REQUEST',
    requestOperacaoAbastecimentos
  ),
  takeLatest(
    '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO',
    deleteOperacaoAbastecimento
  ),
  takeLatest(
    '@operacaoabastecimento/SUCCESS_REMOVE',
    requestOperacaoAbastecimentos
  ),
  takeLatest(
    '@operacaoabastecimento/SUCCESS_REMOVE_FORM',
    requestOperacaoAbastecimentos
  ),
  takeLatest('@operacaoabastecimento/STORE_OPERACAOABASTECIMENTO', store),
  takeLatest('@operacaoabastecimento/FIND_OPERACAOABASTECIMENTO', find),
  takeLatest('@operacaoabastecimento/UPDATE_OPERACAOABASTECIMENTO', update),
  takeLatest(
    '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO_CLIENTE',
    deletarCliente
  ),
  takeLatest('@operacaoabastecimento/RECORD_FILTERING', applyedFilters),
]);
